import { useGetSessionToken } from '@homestake/shared/hooks';
import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack';
import { useEffect, useMemo } from 'react';
import { env } from '../config';

export const useWebsocketConnection = () => {
  const { token } = useGetSessionToken();

  const connection = useMemo(() => {
    return new HubConnectionBuilder()
      .configureLogging(6)
      .withUrl(`${env.VITE_API_URL}/hub`, {
        withCredentials: true,
        accessTokenFactory: () => token as string,
      })
      .withAutomaticReconnect()
      .withHubProtocol(new MessagePackHubProtocol())
      .build();
  }, [token]);

  useEffect(() => {
    if (connection.state === HubConnectionState.Disconnected) {
      connection.start();
    }
    return () => {
      connection.stop();
    };
  }, [connection]);

  return connection;
};
